import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import 'iframe-resizer';

import Home from './components/Home';
import Options from './components/Options';

import { store } from './states/store';

import './index.scss';

const Root = () => {
	const slug =
		window.location.pathname.replace('/', '').replace('/options', '') || 'jota';

	useEffect(() => {
		window.parent.postMessage(
			JSON.stringify({ type: 'CONSENT_IFRAME_READY' }),
			'*',
		);
	}, []);

	return (
		<Provider store={store}>
			<Router basename={`/${slug}`}>
				<Switch>
					<Route exact path="/">
						<Home />
					</Route>
					<Route exact path="/options">
						<Options />
					</Route>
					{/*
					<Route exact path="*">
          	<Redirect to="/" />
          </Route>
					*/}
				</Switch>
			</Router>
		</Provider>
	);
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);
